import styled, { css } from "styled-components";
import { Color, Colors } from "./Colors";
import { NavLink } from "react-router";

export const DateBtnContainer = styled.div`
    // Month picker chevrons 
    & > button {
        background-color: transparent; 
        border: none; 
        height: 28px;
        width: 28px;

        & > svg {
            fill: ${Color(Colors.white)}; 
            width: 16px;
            height: 16px; 
        }
    }
    
    // Month pricker left chevron 
    & > button:first-of-type {
        & > svg {
            transform: rotate(90deg);
            fill: ${({$isPast}) => $isPast ? 'rgba(216, 216, 216, 0.6)' : Color(Colors.white)}
        }
    }
    
    // Month pricker right chevron 
    & > button:last-of-type {
        & > svg {
            transform: rotate(-90deg);
            fill: ${({$isToday}) => $isToday ? 'rgba(216, 216, 216, 0.6)' : Color(Colors.white)}
        }
    }
`;

const MenuBtnBase = css`
  display: flex; 
  justify-content: flex-start; 
  align-items: center; 
  border: none; 
  padding: 8px; 
  text-decoration: none; 
  width: 100%; 
  background-color: transparent; 
  border-radius: 4px; 
  color: ${Color(Colors.black)};

  &[data-scale='true'] svg {
    transform: scale(1.25);
    transform-origin: 50% 50%;
  }

  svg {
    fill: ${Color(Colors.black)}; 
  }
  
  svg {
    height: 24px; 
    width: 24px; 
    margin: 0 8px 0 0; 
    flex: 0 0 24px; 
    display: block; 
  }

  span {
    color: inherit; 
    font-size: 16px; 
  }

  &:hover {
    background-color: ${Color(Colors.lightBlue)}; 
    color: ${Color(Colors.white)}
  }

  @media (max-width: 1150px) {
    justify-content: center; 

    svg {
      margin: 0; 
      height: 26px; 
      width: 26px; 
      flex: 0 0 24px; 
    }

    span {
      display: none; 
    }
  }
`;

export const MenuButton = styled(NavLink)`
  ${MenuBtnBase}

  &.active, 
  &:hover  {
    background-color: ${Color(Colors.lightBlue)}; 

    svg,
    svg > g > path {
      fill: ${Color(Colors.white)}; 
    }
      
    span {
      color: ${Color(Colors.white)}; 
    }
  }

`;

export const ActionButton = styled.button`
  ${MenuBtnBase}

  &:hover svg {
    fill: ${Color(Colors.white)}; 
  }
`;

export const SmallButton = styled.button`
    display: flex;
    justify-content: center; 
    align-items: center; 
    height: 38px;
    max-width: 200px; 
    width: 100%; 
    padding: 0.5rem 1rem 0.5rem 1rem;
    border: none; 
    background-color: ${Color(Colors.blue)}; 
    color: ${Color(Colors.white)}; 
    border-radius: 4px; 
    font-weight: 600; 

    &:first-of-type {
      margin: 0 0 0.5rem 0; 
    }

    &:hover {
        background-color: ${Color(Colors.lightBlue)}; 
    }
`;

export const MediumButton = styled.button`
    border: none;
    border-radius: 4px;
    align-self: center;
    padding: 0.5rem 1rem;
    height: 48px;
    width: 100%;
    font-weight: 600;

    background-color: ${({$theme}) => $theme === 'darkBlue' ? Color(Colors.white) : Color(Colors.blue)};
    color: ${({$theme}) => $theme === 'darkBlue' ? Color(Colors.blue) : Color(Colors.white)};

    &:hover {
        background-color: ${({$theme}) => $theme === 'darkBlue' ? Color(Colors.lightBlue) : $theme === 'lightBlue' ? '#fff' : Color(Colors.lightBlue)};
        color: ${({$theme}) => $theme === 'darkBlue' ? Color(Colors.white) : $theme === 'lightBlue' ? Color(Colors.blue) : Color(Colors.white)};
    }
`;


export const CalendarButton = styled.button`
    display: flex; 
    justify-content: center; 
    align-items: center; 
    border: none; 
    height: 38px; 
    padding: 0.5rem 1rem 0.5rem 1rem;
    border-radius: 4px; 
    width: 315px; 
    font-weight: 600;
    background-color: ${({$isHovered, $isVisible}) => ($isHovered || $isVisible) ? Color(Colors.lightBlue) : Color(Colors.blue)};
    color: ${Color(Colors.white)}; 
    
    & > svg {
        fill: ${Color(Colors.white)}; 
        width: 18px; 
        height: 100%; 
        margin: 0 8px 0 0; 
    }
`;

export const LinkStyle = styled.a`
  color: ${Color(Colors.black)}; 
`; 
